import { render, staticRenderFns } from "./auth-noredirect.vue?vue&type=template&id=610de674&"
import script from "./auth-noredirect.vue?vue&type=script&lang=js&"
export * from "./auth-noredirect.vue?vue&type=script&lang=js&"
import style0 from "./auth-noredirect.vue?vue&type=style&index=0&id=610de674&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports